// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NotFound_wrapper__imlT2","wrapperPublic":"NotFound_wrapperPublic__Nf6U9"};